/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("backstageLoginModule", []).
controller("backstageLoginCtrl", ["$scope", "$state", "$stateParams", "modalDialog", "httpService", "$q", function($scope, $state, $stateParams, modalDialog, httpService, $q) {
    initStatus();
    initData();
    /**
     * [submit description] 提交登录
     * @return {[type]} [description]
     */
    $scope.submit = function() {
        var params = angular.copy($scope.data);
        params.password = encryptedString(bodyRSA(), params.password);
        httpService.http("/mcnadmin/web/user/login.do", params, "post",true,true).then(function(data) {
            if(data.success){
                $state.go("backstage");
            }else{
                $scope.updateImg();
                modalDialog.success(data.message, "success", false, function() {},function() {},'','leftLogin');
            }
        });
    };
    /**
     * [updateImg description] 更新验证码
     * @return {[type]} [description]
     */
    $scope.updateImg = function() {
        var imgArray = $scope.status.verificationCode.split("=");
        imgArray[1] = Math.random();
        $scope.status.verificationCode = imgArray.join("=");
    };
    /**
     * [initData description] 初始化状态
     * @return {[type]} [description]
     */
    function initData() {
        loadEncryptionLib().then(function() {
            encryptionMethods();
        });
        enterEvent();
    }
    /**
     * [initStatus description] 初始化数据
     * @return {[type]} [description]
     */
    function initStatus() {
        httpService.notLogin = false;
        $scope.status = {
            verificationCode: "/mcnadmin/web/code/image.do?V="+new Date().getTime()
        };
        $scope.data = {};
    }

    function enterEvent() {
        function submit(event) {
            if (event.originalEvent.keyCode === 13) {
                $scope.submit();
            }
        }
        $("body").bind("keydown", submit);
        $scope.$on("$destroy", function() {
            $("body").unbind("keydown", submit);
        });
    }
    /**
     * [encryptionMethods description] 加密方法
     * @return {[type]} [description]
     */
    function encryptionMethods() {
        $.ajax({
            url: "/mcnadmin/web/user/publicKey.do",
            dataType: "text",
            success: function(data) {
                $("#encryption").remove();
                $("body").append("<script id='encryption'>" + data + "</script>");
            }
        });
    }
    /**
     * [loadEncryptionLib description] 加载加密依赖文件
     * @return {[type]} [description]
     */
    function loadEncryptionLib() {
        var deffer = $q.defer();
        LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function() {
            deffer.resolve();
        });
        return deffer.promise;
    }
//  /**
//   * [forgetPassword description] 忘记密码
//   * @return {[type]} [description]
//   */
//  $scope.forgetPassword = function() {
//      // httpService.http("/mcnww/web/user/resetpwd.do", "", "get").then(function(data) {
//      //     console.log(data);
//      // });
//      window.open("/mcnww/web/user/resetpwd.do");
//  };

}]);
